<template>
    <v-row dense>
        <v-col cols="12">
            <v-stepper v-model="e6" vertical class="removeBorder">
                <v-stepper-step :complete="e6 > 1" step="1"> Datos Generales </v-stepper-step>
                <v-stepper-content step="1">
                    <StepperDatoGeneralComponent :objForm="objForm.objDatosGen" :listGeneral="listGeneral"
                        :objModal="objModal" :parametro="parametro" :showNext="showNext" />
                </v-stepper-content>

                <v-stepper-step :complete="e6 > 2" step="2"> Datos de Actividad Económica </v-stepper-step>
                <v-stepper-content step="2">
                    <StepperDatoActividadComponent :cargar="e6 == 2 ? true : false" :objForm="objForm.objDatosActEco"
                        :listGeneral="listGeneral" :parametro="parametro" />
                </v-stepper-content>

                <v-stepper-step :complete="e6 > 3" step="3"> Detalles de Ingresos </v-stepper-step>
                <v-stepper-content step="3">
                    <StepperDetalleIngresoComponent :cargar="e6 == 3 ? true : false" :objForm="objForm.objDetalleIng"
                        :listGeneral="listGeneral" />
                </v-stepper-content>

                <v-stepper-step :complete="e6 > 4" step="4"> Referencias Personal </v-stepper-step>
                <v-stepper-content step="4">
                    <StepperReferenciaPersonalComponent :cargar="e6 == 4 ? true : false" :objForm="objForm.objRefPer"
                        :listGeneral="listGeneral" :parametro="parametro" />
                </v-stepper-content>

                <v-stepper-step :complete="e6 > 5" step="5"> Referencias de Instituciones Financieras </v-stepper-step>
                <v-stepper-content step="5">
                    <StepperReferenciaFinancieraComponent :cargar="e6 == 5 ? true : false" :objForm="objForm.objRefBan"
                        :listGeneral="listGeneral" />
                </v-stepper-content>

                <v-stepper-step :complete="e6 > 6" step="6"> Referencias Comerciales </v-stepper-step>
                <v-stepper-content step="6">
                    <StepperReferenciaComercialComponent :cargar="e6 == 6 ? true : false" :objForm="objForm.objRefCom"
                        :listGeneral="listGeneral" />
                </v-stepper-content>

                <v-stepper-step :complete="e6 > 7" step="7"> Documentos Requeridos </v-stepper-step>
                <v-stepper-content step="7">
                    <StepperIngresoDocumentoComponent :cargar="e6 == 7 ? true : false" :objForm="objForm.objDocu"
                        :parametros="parametro"/>
                </v-stepper-content>
            </v-stepper>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'StepperComponentVehiculo',
        props: {
            objDatosGen: {
                type: Object,
                default: {}
            },
            listaGeneral: {
                type: Object,
                default: {}
            },
            parametro: {
                type: Object,
                default: {}
            }
        },
        components: {
            StepperDatoGeneralComponent: () => import(
                '@/components/prevencionLavadoActivo/cliente/StepperDatoGeneralComponent.vue'),
            StepperDatoActividadComponent: () => import(
                '@/components/prevencionLavadoActivo/cliente/StepperDatoActividadComponent.vue'),
            StepperDetalleIngresoComponent: () => import(
                '@/components/prevencionLavadoActivo/cliente/StepperDetalleIngresoComponent.vue'),
            StepperReferenciaPersonalComponent: () => import(
                '@/components/prevencionLavadoActivo/cliente/StepperReferenciaPersonalComponent.vue'),
            StepperReferenciaFinancieraComponent: () => import(
                '@/components/prevencionLavadoActivo/cliente/StepperReferenciaFinancieraComponent.vue'),
            StepperReferenciaComercialComponent: () => import(
                '@/components/prevencionLavadoActivo/cliente/StepperReferenciaComercialComponent.vue'),
            StepperIngresoDocumentoComponent: () => import(
                '@/components/prevencionLavadoActivo/cliente/StepperIngresoDocumentoComponent.vue')
        },
        data: () => ({
            e6: 1,
            objForm: {
                objDatosGen: {},
                objDatosActEco: {},
                objDetalleIng: {},
                objRefPer: {},
                objRefBan: {},
                objRefCom: {},
                objDocu: {},
                idEstado: null
            },
            objModal: {
                titulo: null,
                abrirDialogo: false,
                mostrarFormConyuge: false
            },
            listGeneral: {}
        }),
        created(){
            this.$set(this.objForm, 'objDatosGen', this.objDatosGen);
            this.$set(this, 'listGeneral', this.listaGeneral);
        },
        watch: {
            objDatosGen(val) {
                this.$set(this.objForm, 'objDatosGen', val);
                this.$set(this, 'listGeneral', this.listaGeneral);
            },
            e6(val) {
                switch (val) {
                    case 2:
                        var kDG = ['idFormulario', 'idCertificado', 'idPoliza', 'idCliente', 'idCanton'];
                        var kDAE = ['idProfesion', 'actEconomica', 'idTipoFuenteIngreso'];

                        var objeto = _.merge({}, this.objForm.objDatosActEco,
                            _.pick(this.objForm.objDatosGen, kDG),
                            _.pick(this.objForm.objDatosActEco, kDAE), {
                                idEstado: _.toString(this.parametro.idEstadoDefault)
                            }
                        );

                        this.$set(this.objForm, 'objDatosActEco', objeto);
                        break;
                    case 3:
                        var kDG = ['idFormulario', 'idCertificado', 'idPoliza', 'idCliente'];
                        var kDAE = ['idProfesion', 'actEconomica'];
                        var kDI = ['ingresoMensual', 'egresoMensual', 'activos', 'pasivos', 'patrimonio',
                            'otrosIngresos'
                        ];

                        var objeto = _.merge({}, this.objForm.objDatosActEco,
                            _.pick(this.objForm.objDatosGen, kDG),
                            _.pick(this.objForm.objDatosActEco, kDAE),
                            _.pick(this.objForm.objDetalleIng, kDI), {
                                idEstado: _.toString(this.parametro.idEstadoDefault),
                                idEstadoProcesado: _.toString(this.parametro.idEstadoDefault)
                            }
                        );

                        this.$set(this.objForm, 'objDetalleIng', objeto);
                        break;

                    case 4:
                        var kDG = ['idFormulario', 'idCertificado', 'idPoliza', 'idCliente'];
                        var kORP = ['nombres', 'apellidos', 'parentesco', 'direccion', 'idProvincia', 'idCanton'];

                        var objeto = _.merge({}, this.objForm.objRefPer,
                            _.pick(this.objForm.objDatosGen, kDG),
                            _.pick(this.objForm.objRefPer, kORP), {
                                idEstado: _.toString(this.parametro.idEstadoDefault),
                            }
                        );

                        this.$set(this.objForm, 'objRefPer', objeto);
                        break;

                    case 5:
                        var kDG = ['idFormulario', 'idCertificado', 'idPoliza', 'idCliente'];
                        var kORB = ['idTipoCuenta', 'nroCuenta', 'idInstitucionFinanciera'];

                        var objeto = _.merge({}, this.objForm.objRefBan,
                            _.pick(this.objForm.objDatosGen, kDG),
                            _.pick(this.objForm.objRefBan, kORB), {
                                idEstado: _.toString(this.parametro.idEstadoDefault),
                            }
                        );

                        this.$set(this.objForm, 'objRefBan', objeto);
                        break;

                    case 6:
                        var kDG = ['idFormulario', 'idCertificado', 'idPoliza', 'idCliente'];
                        var kORC = ['institucion', 'producto', 'telefono'];

                        var objeto = _.merge({}, this.objForm.objRefCom,
                            _.pick(this.objForm.objDatosGen, kDG),
                            _.pick(this.objForm.objRefCom, kORC), {
                                idEstado: _.toString(this.parametro.idEstadoDefault),
                            }
                        );

                        this.$set(this.objForm, 'objRefCom', objeto);
                        break;

                    case 7:

                        this.$set(this.objForm, 'objDocu',  this.objForm.objDocu);
                        break;
                }
            }
        },
        computed: {
            showNext() {
                var lista = this.listGeneral;
                return _.size(_.get(lista, 'listaCertificados', [])) > 0 ? true : false;
            }
        },
        methods: {
            next(nameObject, data, band = true) {
                if (_.isArray(data))
                    this.$set(this.listGeneral, nameObject, data);
                else
                    this.$set(this.objForm, nameObject, _.merge({}, _.get(this.objForm, nameObject, {}), data));

                if (band)
                    ++this.e6;
            },
            previous(nameObject, data, band = true) {
                if (_.isArray(data))
                    this.$set(this.listGeneral, nameObject, data);
                else
                    this.$set(this.objForm, nameObject, _.merge({}, _.get(this.objForm, nameObject, {}), data));

                if (band)
                    --this.e6;
            },
            onListarCatalogo(opcion, lista) {
                var error = 'E';

                return axios.post(`${BASE_URI}administrador/catalogo-estado/listar`, {
                        opcion: opcion
                    })
                    .then((r) => {
                        if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r, ['data', 'data'], [])) == 0) {
                            error = 'I';
                            throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion);
                        }
                        this.$set(this.listGeneral, lista, r.data.data);
                        return r;
                    })
                    .catch((e) => {
                        mensajesAlerta(e, error);
                        return e;
                    })
            },
            insertarActualizar(){
                this.$set(this.objForm.objDetalleIng,'idFormulario',this.objForm.objDatosGen.idFormulario);
                this.$set(this.objForm.objDetalleIng,'idEstadoProcesado',this.parametro.idEstadoDefault);
                var error = 'E';
                var objeto = {
                    opcion                          : _.size(this.objForm.objDatosGen.idFormulario) > 0 ? 'U' : 'I',
                    objDetalleIng                   : this.objForm.objDetalleIng,
                    listaFile                       : _.get(this.listGeneral,'listDocumentos',[]),
                    detalleFuenteIngresoDep         : _.get(this.listGeneral,'detalleFuenteIngresoDep',[]),
                    detalleFuenteIngresoInd         : _.get(this.listGeneral,'detalleFuenteIngresoInd',[]),
                    listaReferenciaComercial        : _.get(this.listGeneral,'listaReferenciaComercial',[]),
                    listaReferenciaPersonal         : _.get(this.listGeneral,'listaReferenciaPersonal',[]),
                    listaReferenciaFinanciera       : _.get(this.listGeneral,'listaReferenciaFinanciera',[]),
                }
                
                return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/insertOrUpdate`,objeto)
                            .then((r) => {
                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                    mensajeAlertaTiempo(r.data.mensaje,'S');
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 1600);
                                    
                                return r;
                            })
                            .catch((e)=>{
                                mensajesAlerta(e,error);
                                return e;
                            })
            },
        },
        provide() {
            return {
                next: this.next,
                previous: this.previous,
                onListarCatalogo: this.onListarCatalogo,
                insertarActualizar : this.insertarActualizar
            }
        }
    }
</script>

<style>
    .removeBorder {
        box-shadow: none !important;
    }
</style>